/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  font-size: 0.8571428571rem;
  display: block;
  height: 1.2857142857rem;
  flex: 0 0 auto;
}
:host #icon {
  top: 0.0714285714rem;
  margin-top: -0.6428571429rem;
  height: 1rem;
  width: 1rem;
}
:host svg {
  fill: #C5CACC;
  fill: var(--davinci-color-outline-light, #C5CACC);
}
:host .breadcrumb-item {
  color: #737F85;
  color: var(--davinci-color-text-lighter, #737F85);
  text-decoration: none;
  background-color: rgba(255, 255, 255, 0);
  line-height: 1.2857142857rem;
  font-size: 0.8571428571rem;
  font-weight: bold;
  margin: 0 0.1428571429rem 0 0.1428571429rem;
}
:host .breadcrumb-item:hover {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}

:host(:focus) {
  outline: none;
}

:host a {
  border-bottom: 1px solid rgba(255, 255, 255, 0);
}
:host a:focus {
  outline: none;
  border-bottom: 1px solid var(--davinci-color-outline-light,#C5CACC);
}

:host([hidden]) {
  display: none;
}

:host(:first-child) #icon {
  display: none;
}
:host(:first-child) .breadcrumb-item {
  margin-left: 0;
}

:host(:last-child) .breadcrumb-item {
  font-weight: normal;
  cursor: default;
  margin-right: 0;
  pointer-events: none;
}
:host(:last-child) .breadcrumb-item:hover {
  color: #737F85;
  color: var(--davinci-color-text-lighter, #737F85);
}`;
export { style };
